module.exports = __webpack_public_path__ + "media/images/flags/32/Ethiopia-2cc67120a049a5a23f7010cfdf9eed0e.png";